// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-77577e58] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.resource[data-v-77577e58] {
  display: flex;
  align-items: center;
  height: var(--default-clickable-area);
}
.resource__button[data-v-77577e58] {
  width: 100% !important;
  justify-content: flex-start !important;
  padding: 0 !important;
}
.resource__button[data-v-77577e58] .button-vue__wrapper {
  justify-content: flex-start !important;
}
.resource__button[data-v-77577e58] .button-vue__wrapper .button-vue__text {
  font-weight: var(--font-weight-default, normal) !important;
  margin-inline-start: 2px !important;
}
.resource__icon[data-v-77577e58] {
  width: 32px;
  height: 32px;
  background-color: var(--color-text-maxcontrast);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resource__icon img[data-v-77577e58] {
  width: 16px;
  height: 16px;
  filter: var(--background-invert-if-dark);
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-10ef45ac] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.team-resources__header[data-v-10ef45ac] {
  font-weight: var(--font-weight-heading, bold);
  margin-bottom: 6px;
}
.related-team[data-v-10ef45ac] {
  border-radius: var(--border-radius-container);
  border: 2px solid var(--color-border-dark);
  margin-bottom: 6px;
}
.related-team__open[data-v-10ef45ac] {
  border-color: var(--color-primary-element);
}
.related-team__header[data-v-10ef45ac] {
  padding: 6px;
  padding-inline-end: 24px;
  display: flex;
  gap: 12px;
}
.related-team__name[data-v-10ef45ac] {
  display: flex;
  flex-grow: 1;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  font-weight: var(--font-weight-heading, bold);
  margin: 0;
}
.related-team .related-team-provider[data-v-10ef45ac] {
  padding: 6px 12px;
}
.related-team .related-team-provider__name[data-v-10ef45ac] {
  font-weight: var(--font-weight-heading, bold);
  margin-bottom: 3px;
}
.related-team .related-team-provider__link[data-v-10ef45ac] {
  display: flex;
  gap: 12px;
  padding: 6px 12px;
  font-weight: var(--font-weight-heading, bold);
}
.related-team .related-team-resource__link[data-v-10ef45ac] {
  display: flex;
  gap: 12px;
  height: var(--default-clickable-area);
  align-items: center;
  border-radius: var(--border-radius-element);
}
.related-team .related-team-resource__link[data-v-10ef45ac]:hover {
  background-color: var(--color-background-hover);
}
.related-team .related-team-resource__link[data-v-10ef45ac]:focus {
  background-color: var(--color-background-hover);
  outline: 2px solid var(--color-primary-element);
}
.related-team .related-team-resource .resource__icon[data-v-10ef45ac] {
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.related-team .related-team-resource .resource__icon > img[data-v-10ef45ac] {
  border-radius: var(--border-radius-pill);
  overflow: hidden;
  width: 32px;
  height: 32px;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-78029c82] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.related-resources__header h5[data-v-78029c82] {
  font-weight: var(--font-weight-heading, bold);
  margin-bottom: 6px;
}
.related-resources__header p[data-v-78029c82] {
  color: var(--color-text-maxcontrast);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcRelatedResourcesPanel-CiG_Ixb6.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,0DAA0D;EAC1D,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,6CAA6C;EAC7C,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6CAA6C;EAC7C,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,+CAA+C;AACjD;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-77577e58] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.resource[data-v-77577e58] {\n  display: flex;\n  align-items: center;\n  height: var(--default-clickable-area);\n}\n.resource__button[data-v-77577e58] {\n  width: 100% !important;\n  justify-content: flex-start !important;\n  padding: 0 !important;\n}\n.resource__button[data-v-77577e58] .button-vue__wrapper {\n  justify-content: flex-start !important;\n}\n.resource__button[data-v-77577e58] .button-vue__wrapper .button-vue__text {\n  font-weight: var(--font-weight-default, normal) !important;\n  margin-inline-start: 2px !important;\n}\n.resource__icon[data-v-77577e58] {\n  width: 32px;\n  height: 32px;\n  background-color: var(--color-text-maxcontrast);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.resource__icon img[data-v-77577e58] {\n  width: 16px;\n  height: 16px;\n  filter: var(--background-invert-if-dark);\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-10ef45ac] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.team-resources__header[data-v-10ef45ac] {\n  font-weight: var(--font-weight-heading, bold);\n  margin-bottom: 6px;\n}\n.related-team[data-v-10ef45ac] {\n  border-radius: var(--border-radius-container);\n  border: 2px solid var(--color-border-dark);\n  margin-bottom: 6px;\n}\n.related-team__open[data-v-10ef45ac] {\n  border-color: var(--color-primary-element);\n}\n.related-team__header[data-v-10ef45ac] {\n  padding: 6px;\n  padding-inline-end: 24px;\n  display: flex;\n  gap: 12px;\n}\n.related-team__name[data-v-10ef45ac] {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 12px;\n  font-weight: var(--font-weight-heading, bold);\n  margin: 0;\n}\n.related-team .related-team-provider[data-v-10ef45ac] {\n  padding: 6px 12px;\n}\n.related-team .related-team-provider__name[data-v-10ef45ac] {\n  font-weight: var(--font-weight-heading, bold);\n  margin-bottom: 3px;\n}\n.related-team .related-team-provider__link[data-v-10ef45ac] {\n  display: flex;\n  gap: 12px;\n  padding: 6px 12px;\n  font-weight: var(--font-weight-heading, bold);\n}\n.related-team .related-team-resource__link[data-v-10ef45ac] {\n  display: flex;\n  gap: 12px;\n  height: var(--default-clickable-area);\n  align-items: center;\n  border-radius: var(--border-radius-element);\n}\n.related-team .related-team-resource__link[data-v-10ef45ac]:hover {\n  background-color: var(--color-background-hover);\n}\n.related-team .related-team-resource__link[data-v-10ef45ac]:focus {\n  background-color: var(--color-background-hover);\n  outline: 2px solid var(--color-primary-element);\n}\n.related-team .related-team-resource .resource__icon[data-v-10ef45ac] {\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.related-team .related-team-resource .resource__icon > img[data-v-10ef45ac] {\n  border-radius: var(--border-radius-pill);\n  overflow: hidden;\n  width: 32px;\n  height: 32px;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-78029c82] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.related-resources__header h5[data-v-78029c82] {\n  font-weight: var(--font-weight-heading, bold);\n  margin-bottom: 6px;\n}\n.related-resources__header p[data-v-78029c82] {\n  color: var(--color-text-maxcontrast);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
